import store from 'store/storeConfig';

/**
 * Gets the localized short gender for the patient (M, F, O, U).
 * @param {Object} patient the patient for which you need the gender
 * @returns the localized gender
 */
export const getShortPatientGender = (gender: string | undefined): string => {
  const { intl } = store.getState();
  switch (gender) {
    case '1':
    case intl.messages.maleGenderKey:
      return intl.messages.maleGenderKey;
    case '2':
    case intl.messages.femaleGenderKey:
      return intl.messages.femaleGenderKey;
    case '3':
    case intl.messages.otherGenderKey:
      return intl.messages.otherGenderKey;
    case '4':
    case intl.messages.unknownGenderKey:
    default:
      return intl.messages.unknownGenderKey;
  }
};

/**
 * Gets the string key for long patient gender or its associated number
 * @param gender the long string key or number as a string
 * @returns the string key for long patient gender
 */
export const getLongPatientGender = (gender: string | undefined) => {
  if (gender === undefined) return '';
  const { intl } = store.getState();
  switch (gender) {
    case '1':
    case intl.messages.maleGenderKey:
      return 'male';
    case '2':
    case intl.messages.femaleGenderKey:
      return 'female';
    case '3':
    case intl.messages.otherGenderKey:
      return 'other';
    case '4':
    case intl.messages.unknownGenderKey:
    default:
      return 'unknown';
  }
};

/**
 * Gets the number (as a string) equivalent to the given short or long string key
 * @param gender the short or long string key
 * @returns the number as a string
 */
export const genderToNumber = (gender: string | undefined) => {
  const { intl } = store.getState();
  switch (gender) {
    case 'male':
    case intl.messages.maleGenderKey:
      return '1';
    case 'female':
    case intl.messages.femaleGenderKey:
      return '2';
    case 'other':
    case intl.messages.otherGenderKey:
      return '3';
    case 'unknown':
    case intl.messages.unknownGenderKey:
    default:
      return '4';
  }
};
